import React, { useCallback, useEffect, useReducer, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import {
  Typography,
  Button,
  Row,
  InputNumber,
  Form,
  Input,
  Modal,
  Table,
  Select,
  Space,
} from 'antd';
import moment from 'moment';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from 'reducers';
import { useTranslation } from 'react-i18next';

import { PatternCodeType } from 'components/Admin/PatternCode';
import { message, SetDefaultWarehouseDialog } from 'components/common';
import { LS_DEFAULT_WAREHOUSE_KEY } from 'constants/config';
import { queryLocationsByKeyword } from 'services/warehouse';
import {
  fetchWarehouseProductList2,
  // moveProductLocationToLocation,
  moveProductLocationToLocation2,
} from 'services/inventory';
import {
  getProfileSettingValue,
  //getStorage,
  getWarehouseIdFromCache,
  getWarehouseCodeFromCache,
  playAudio,
} from 'utils';
import {
  SmartSpace,
  SmartFormLabel,
  GreenColor,
  SmartRow,
  SmartScanner,
  SmartBackButton,
  SmartSpin,
} from '../../SmartComponent';
import {
  clearMatchedPatternList,
  extractPatternCodeList,
  getMatchedPatternCode,
  isAnyPatternMatched,
  isPatternCodeEnabled,
} from '../../PoReceive';
import PatternCodeSelector from '../../PoReceive/PatternCodeSelector';
import FinishDialog from './Finish';
import {
  //DefaultScanRecvRatio,
  defaultUom,
  //ScanRecvCountType,
  //ScanRecvLotPolicy,
  //ScanRecvRatioType,
  PoRecvActionType as PRAction,
  //PoRecvStep,
  initialState,
  //isValidStep,
  reducer,
} from './context';

const { Text } = Typography;

const getStateFromStorage = () => {
  const state: StringKAnyVPair = {};
  //const storage = getStorage('session');

  /*
  const scanRecvCountType = storage.getItem(PoRecvStorageKey.ScanRecvCountType);
  if (scanRecvCountType !== null && !isNaN(Number(scanRecvCountType))) state.scanRecvCountType = Number(scanRecvCountType);
  const scanRecvLotPolicy = storage.getItem(PoRecvStorageKey.ScanRecvLotPolicy);
  if (scanRecvLotPolicy !== null && !isNaN(Number(scanRecvLotPolicy))) state.scanRecvLotPolicy = Number(scanRecvLotPolicy);
  const scanRecvLotUniNum = storage.getItem(PoRecvStorageKey.ScanRecvLotUniNum);
  if (scanRecvLotUniNum !== null) state.scanRecvLotUniNum = scanRecvLotUniNum;
  const scanRecvRatio = storage.getItem(PoRecvStorageKey.ScanRecvRatio);
  if (scanRecvRatio !== null && !isNaN(Number(scanRecvRatio))) state.scanRecvRatio = Number(scanRecvRatio);
  const scanRecvRatioType = storage.getItem(PoRecvStorageKey.ScanRecvRatioType);
  if (scanRecvRatioType !== null && !isNaN(Number(scanRecvRatioType))) state.scanRecvRatioType = Number(scanRecvRatioType);
  */

  return state;
};

export default function ReturnToLocation(): JSX.Element {
  const history = useHistory();
  const whs = useSelector(
    (state: RootState) => state.admin.warehouses,
    shallowEqual
  );
  const { t } = useTranslation();
  const [fetching, setFetching] = useState(false);
  // const [locations, setLocations] = useState<WarehouseLocationRow[]>([]);
  const [finishDialogVisible, setFinishDialogVisible] = useState(false);
  const [step, setStep] = useState<string>('sourceLocation'); //'sourceLocation' | 'targetLocation' | 'scanItem' | 'scanQty'
  const [sLocation, setSLocation] = useState<WarehouseLocationRow>();
  const [tLocation, setTLocation] = useState<WarehouseLocationRow>();
  const [productLocations, setProductLocations] = useState<any[]>([]);
  const [qty, setQty] = useState<number>(0);
  const [inputValue, setInputValue] = useState<string>('');
  const [scanTime, setScanTime] = useState<string>('');
  const [uomEnable, setUomEnable] = useState(true);
  const [lastLocationTabelVersion, setLastLocationTableVersion] = useState(0);
  const [locationTabelVersion, setLocationTableVersion] = useState(0);
  const [lotEnable, setLotEnable] = useState(true);
  const [patternCodeSelectorVisible, setPatternCodeSelectorVisible] = useState(false);
  const [patternCodeState, setPatternCodeState] = useState<StringKAnyVPair>({});
  const [showUsePick, setShowUsePick] = useState(false);
  const [selectedLotUom, setSelectedLotUom] = useState<any>();
  const [warehouseNum, setWarehouseNum] = useState<number>(-1);
  const [warehouseId, setWarehouseId] = useState<string>('');
  const [dialogClosable, setDialogClosable] = React.useState(true);
  const [defaultWarehouseVisible, setDefaultWarehouseVisible] =
    React.useState(false);

  const [state, dispatch] = useReducer(reducer, initialState(getStateFromStorage()));

  // eslint-disable-next-line
  const checkSourceLocationItemsForPatternCode = (items: StringKAnyVPair[]) => {
    if (isPatternCodeEnabled(state)) {
      const st: StringKAnyVPair = {};
      let count = 0;

      setPatternCodeState({});
      items.forEach(e => {
        isLocationItemUsable(e) && (count += 1);
      });
      st.notUsable = (count !== 1);
      console.log('c', count);
      if (st.notUsable) {
        st.message = count > 1 ? 'More than 1 usable items found' : 'No usable item found';
        setPatternCodeState(st);
      }
    }
  };

  const closePatternCodeSelector = () => {
    setPatternCodeSelectorVisible(false);
  };

  const onClosePatternCodeSelectorWithoutSelection = () => {
    //tryOpenDefaultLocationDialogWithoutPatternCode();
  };

  const onSelectPatternCode = (pat: StringKAnyVPair) => {
    /*
    const location = (pat.items || []).find((p: StringKAnyVPair) => p.valueType === PatternCodeType.Location);
    //console.log('p', location);
    !location && openDefaultLocationDialog();
    */
  };

  const openSetDefaultWarehouseDialog = (config: StringKAnyVPair) => {
    setDialogClosable(
      typeof config.closable === 'boolean' ? config.closable : true
    );
    setDefaultWarehouseVisible(true);
  };

  const openPatternCodeSelector = () => {
    setPatternCodeSelectorVisible(true);
  };

  React.useEffect(() => {
    if (
      !localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY) ||
      !getWarehouseCodeFromCache(
        Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY))
      )
    ) {
      openSetDefaultWarehouseDialog({ closable: false });
    }
  }, []);

  React.useEffect(() => {
    if (whs) {
      const exist = whs.filter(
        (e) =>
          e.id === Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)) &&
          (e.warehouseType === 1 || e.warehouseType === 5)
      );
      if (exist.length === 0) {
        openSetDefaultWarehouseDialog({ closable: false });
      }
    }
  }, [whs]);

  useEffect(() => {
    if (localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)) {
      setWarehouseNum(Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)));
      setWarehouseId(
        getWarehouseIdFromCache(
          Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY))
        )
      );
    }
  }, []);

  const getSetting = useCallback(async () => {
    const res1 = await getProfileSettingValue('EnableLOT', '0');
    const res2 = await getProfileSettingValue('EnableUOM', '0');
    const res3 = await getProfileSettingValue('EnableMultiPurpostProductCode', '0');
    setLotEnable(res1 === '1');
    setUomEnable(res2 === '1');
    dispatch({ type: PRAction.SetEnableMultiPurposeCode, params: res3 === '1' });

    if (res3 === '1') openPatternCodeSelector();
  }, []);

  useEffect(() => {
    getSetting();
  }, [getSetting]);

  const getColumns = useCallback(() => {
    let temp: any[] = [
      {
        title: 'LOC#',
        dataIndex: 'locationCode',
        key: 'locationCode',
      },
      {
        title: 'LOT#',
        dataIndex: 'lotNumber',
        key: 'lotNumber',
      },
      {
        title: 'UOM',
        dataIndex: 'uom',
        key: 'uom',
      },
      {
        title: 'Rate',
        dataIndex: 'uomRate',
        key: 'uomRate',
      },
      {
        title: 'Base Qty',
        dataIndex: 'uomBaseQty',
        key: 'uomBaseQty',
      },
    ];
    temp = lotEnable ? temp : temp.filter((i) => i.dataIndex !== 'lotNumber');
    temp = uomEnable
      ? temp
      : temp.filter((i) => ['uom', 'uomRate'].indexOf(i.dataIndex) === -1);
    return temp;
  }, [lotEnable, uomEnable]);

  const getDefaultLot = (list: any[], locationCode: any) => {
    if (isPatternCodeEnabled(state)) {
      const lot = getMatchedPatternCode(state.matchedPatternList, PatternCodeType.LOT);
      //const uom = getMatchedPatternCode(state.matchedPatternList, PatternCodeType.UOM);
      const item = list.find(e => (locationCode ? e.locationCode === locationCode : true) && e.lotNumber === lot);
      //console.log('l', lot, uom, item);
      return item ? `${item.lotNumber}` : getDefaultSelect(list, locationCode);
    } else return getDefaultSelect(list, locationCode);
  };

  const getDefaultLotUom = (list: any[], locationCode: any) => {
    if (isPatternCodeEnabled(state)) {
      const lot = getMatchedPatternCode(state.matchedPatternList, PatternCodeType.LOT);
      const uom = getMatchedPatternCode(state.matchedPatternList, PatternCodeType.UOM);
      const item = list.find(e => (locationCode ? e.locationCode === locationCode : true) && e.lotNumber === (lot || '') && e.uom === uom);
      //console.log('l', lot, uom, item, list);
      (item && !selectedLotUom) && setSelectedLotUom(item);
      return item ? `${item.lotNumber}_##___##_${item.uom}` : getDefaultSelect(list, locationCode);
    } else return getDefaultSelect(list, locationCode);
  };

  const getDefaultUom = (list: any[], locationCode: any) => {
    if (isPatternCodeEnabled(state)) {
      //const lot = getMatchedPatternCode(state.matchedPatternList, PatternCodeType.LOT);
      const uom = getMatchedPatternCode(state.matchedPatternList, PatternCodeType.UOM);
      const item = list.find(e => (locationCode ? e.locationCode === locationCode : true) && e.uom === uom);
      //console.log('l', uom, item);
      return item ? `${item.uom}` : getDefaultSelect(list, locationCode);
    } else return getDefaultSelect(list, locationCode);
  };

  const getDefaultSelect = (list: any[], locationCode: any) => {
    const temp = list.filter((i) => i.locationCode === locationCode);
    if (temp.length === 1) {
      return `${temp[0].lotNumber}_##___##_${temp[0].uom}`;
    } else {
      return undefined;
    }
  };

  useEffect(() => {
    if (step === 'scanQty') {
      const temp = productLocations.filter(
        (i) => i.locationCode === sLocation?.locationCode
      );
      if (temp.length === 1 && (uomEnable || lotEnable)) {
        setSelectedLotUom(temp[0]);
      }
    }

    if (lastLocationTabelVersion !== locationTabelVersion) {
      if (isPatternCodeEnabled(state)) {
        if (productLocations.length > 0) {
          checkSourceLocationItemsForPatternCode(productLocations);
        }
      }

      setLastLocationTableVersion(locationTabelVersion);
    }
  }, [
    checkSourceLocationItemsForPatternCode,
    lastLocationTabelVersion,
    locationTabelVersion,
    productLocations,
    state,
    step,
    uomEnable,
    lotEnable,
    sLocation,
  ]);

  const handleKeyDown = async (evt: any) => {
    if ([9, 13].indexOf(evt.keyCode) > -1) {
      setInputValue('');
      evt.preventDefault();
      if (evt.target.value) {
        if (
          evt.target.value === productLocations[0].sku ||
          evt.target.value === productLocations[0].upc
        ) {
          playAudio('success');
          setQty((prev) => prev + 1);
          setScanTime(moment().format('hh:mm:ssA'));
        } else {
          playAudio('error');
          message.info({ content: 'not match item' });
        }
      }
    }
  };

  const isPatternCodeIncludeLotOrUom = () => {
    let ret = false;

    if (isPatternCodeEnabled(state)) {
      const lot = getMatchedPatternCode(state.matchedPatternList, PatternCodeType.LOT);
      const uom = getMatchedPatternCode(state.matchedPatternList, PatternCodeType.UOM);

      ret = !!(lot || uom);
    }

    return ret;
  };

  const isTargetLocationScannerDisabled = () => {
    return isPatternCodeEnabled(state) ? patternCodeState.notUsable : false;
  };

  const moveProduct = useCallback(async () => {
    try {
      if ((uomEnable || lotEnable) && !selectedLotUom) {
        message.info('LOT# or UOM required');
        return;
      }
      setFetching(true);
      const res = await moveProductLocationToLocation2({
        fromWarehouse: warehouseId,
        fromLocation: sLocation?.locationNum || -1,
        fulfillmentProductNum: productLocations[0].fulfillmentProductNum,
        quantity: qty,
        toWarehouse: warehouseNum,
        toLocation: tLocation?.locationNum || -1,
        lotNumber:
          selectedLotUom && lotEnable ? selectedLotUom.lotNumber : undefined,
        uom: selectedLotUom && uomEnable ? selectedLotUom.uom : undefined,
        uomRate:
          selectedLotUom && uomEnable ? selectedLotUom.uomRate : undefined,
      });
      // const res = await moveProductLocationToLocation({
      //   fromWarehouse: warehouseId,
      //   fromLocation: sLocation?.locationNum || -1,
      //   fulfillmentProductNum: productLocations[0].fulfillmentProductNum,
      //   quantity: qty,
      //   toWarehouse: warehouseNum,
      //   toLocation: tLocation?.locationNum || -1,
      // });
      setFetching(false);
      if (res) {
        setFinishDialogVisible(true);
        // message.success({ content: 'Move successfully' });
      }
    } catch (error) {
      setFetching(false);
    }
  }, [
    sLocation,
    tLocation,
    warehouseId,
    productLocations,
    qty,
    warehouseNum,
    lotEnable,
    selectedLotUom,
    uomEnable,
  ]);

  const fetchProductsByLocationCode = async (sk: string) => {
    let code = sk;

    if (isPatternCodeEnabled(state)) {
      const pl = extractPatternCodeList(state, sk);
      const patternMatched = isAnyPatternMatched(pl || []);

      if (pl && patternMatched && getMatchedPatternCode(pl, PatternCodeType.SKU)) {
        const codeList: StringKAnyVPair[] = [];
        const pQty = getMatchedPatternCode(pl, PatternCodeType.Qty);

        (pl || []).forEach(e => codeList.push(e));
        dispatch({ type: PRAction.SetMatchedPatternList, params: codeList });
        code = getMatchedPatternCode(pl, PatternCodeType.SKU);
        //setInputValue(code);
        (!isNaN(Number(pQty))) && setQty(pQty);
      }
      //console.log('pm', patternMatched, pl);
    }

    try {
      const params = {
        warehouseNum: warehouseNum,
        uniqueCode: code,
      };
      setFetching(true);
      const res = await fetchWarehouseProductList2(params);
      setFetching(false);
      if (res.length > 0) {
        const temp = res.filter(
          (item: any) =>
            item.locationCode === sLocation?.locationCode &&
            item.locationCode !== 'Checkout'
        );
        console.log(temp, res);
        if (temp.length > 0) {
          setProductLocations(
            res.filter((item: any) => item.locationCode !== 'Checkout')
          );
          setStep('targetLocation');
          (Object(patternCodeState).length > 0) && setPatternCodeState({});

          if (isPatternCodeEnabled(state)) {
            setLocationTableVersion(locationTabelVersion + 1);
          }
        } else {
          message.error({
            content: `not found Item from '${sLocation?.locationCode}'`,
          });
        }
      } else {
        message.error({ content: 'not found Item' });
      }
    } catch (error) {
      setFetching(false);
    }
  };

  const isLocationItemUsable = (item: StringKAnyVPair, checkSourceLocation = true, checkQty = true) => {
    let ret = true;

    if (isPatternCodeEnabled(state)) {
      const lot =  getMatchedPatternCode(state.matchedPatternList, PatternCodeType.LOT) || '';
      const uom =  getMatchedPatternCode(state.matchedPatternList, PatternCodeType.UOM) || defaultUom.uom;
      const qty =  getMatchedPatternCode(state.matchedPatternList, PatternCodeType.Qty) || 1;
      let match = checkSourceLocation ? item.locationCode === sLocation?.locationCode : true;
      //let match = false;

      match && (match = lotEnable ? item.lotNumber === lot : true);
      //match && console.log('m', match, item.locationCode, sLocation);
      match && (match = uomEnable ? item.uom === uom : true);
      (match && checkQty) && (match = item.uomBaseQty >= qty);
      //match && console.log('mm', match, lot, uom, qty, item);
      ret = match;
    }

    return ret;
  };

  const onLocationTableRow = (row: StringKAnyVPair, idx: any) => {
    const getRowClassName = (row: StringKAnyVPair) => {
      let cls = '';

      if (row.locationCode === sLocation?.locationCode) {
        cls = 'tr-bg-grey-01';

        if (isPatternCodeEnabled(state)) {
          const qty =  getMatchedPatternCode(state.matchedPatternList, PatternCodeType.Qty) || 1;
          let match = isLocationItemUsable(row, true, false);

          if (match) {
            match = row.uomBaseQty >= qty;
            cls = match ? 'tr-bg-green-01' : 'tr-bg-red-01';
          }
        }
      }

      return cls;
    };

    return {
      className: getRowClassName(row),
    };
  };

  const queryLocation = useCallback(
    async (value: string, step: string, callback: (value: any) => void) => {
      try {
        setFetching(true);
        const res = await queryLocationsByKeyword(warehouseId, value, true);
        setFetching(false);

        if (!res.error) {
          callback(res);
          if (step.length > 0) {
            setStep(step);
          }
        }
      } catch (error) {
        setFetching(false);
      }
    },
    [warehouseId]
  );

  const sortLocationList = (list: StringKAnyVPair[]) => {
    const data = [...list];
    const gd: StringKAnyVPair = {};
    const gl: StringKAnyVPair[][] = [];
    let ret: StringKAnyVPair[] = [];

    data.forEach(e => {
      (!gd[e.locationCode]) && (gd[e.locationCode] = []);
      gd[e.locationCode].push(e);
    });

    for (const k in gd) gl.push(gd[k]);

    gl.sort((a, b) => (a[0].locationCode === sLocation?.locationCode) ? -1 : 1);
    gl.forEach(g => {
      g.sort((a, b) => {
        let cmp = 0;

        if (isPatternCodeEnabled(state)) {
          const lot =  getMatchedPatternCode(state.matchedPatternList, PatternCodeType.LOT);
          //const uom =  getMatchedPatternCode(state.matchedPatternList, PatternCodeType.UOM);
          //const qty =  getMatchedPatternCode(state.matchedPatternList, PatternCodeType.Qty);
          cmp = lot ? (a.lotNumber.localeCompare(lot) - b.lotNumber.localeCompare(lot)) : a.lotNumber.localeCompare(b.lotNumber);
          (cmp === 0) && (cmp = b.uomBaseQty - a.uomBaseQty);
        } else {
          cmp = a.lotNumber.localeCompare(b.lotNumber);
          (cmp === 0) && (cmp = b.uomBaseQty - a.uomBaseQty);
        }

        return cmp;
      });

      ret = [...ret, ...g];
    });
    console.log('gl', gl, sLocation);

    return ret;
  };

  // const getLocations = useCallback(async () => {
  //   try {
  //     setFetching(true);
  //     const res = await fetchWarehouseLocationList(warehouseId, true);
  //     setFetching(false);
  //     setLocations(res);
  //   } catch (error) {
  //     setFetching(false);
  //   }
  // }, [warehouseId]);

  /* eslint-disable */
  // useEffect(() => {
  //   if (warehouseId && locations.length === 0) {
  //     getLocations();
  //   }
  // }, [warehouseId]);
  /* eslint-enable */

  return (
    <div style={{ marginTop: 20 }}>
      {step === 'sourceLocation' && (
        <>
          <SmartSpin loading={fetching} />
          <SmartSpace>
            <SmartFormLabel
              style={{ color: GreenColor, fontWeight: 600, fontSize: 18 }}
            >
              {t('smart.movemerge.scanSourceLocationtoStart')}
            </SmartFormLabel>
            <SmartScanner
              style={{ marginTop: 10 }}
              onChangeValue={(value) => {
                queryLocation(value, 'scanItem', setSLocation);

                // const temp = locations.filter((i) => i.code === value);
                // if (temp.length > 0) {
                //   setSLocation(temp[0]);
                //   setStep('scanItem');
                // } else {
                //   message.error('No matching location');
                // }
              }}
            />
          </SmartSpace>
          <SmartRow justify="space-between">
            <Button
              type="text"
              onClick={() => {
                queryLocation('General', 'scanItem', setSLocation);
                // const temp = locations.filter((i) => i.code === 'General');
                // if (temp.length > 0) {
                //   setSLocation(temp[0]);
                //   setStep('scanItem');
                // } else {
                //   message.error('No matching location [General]');
                // }
              }}
            >
              Use General
            </Button>
            <Button type="text" onClick={() => setShowUsePick((prev) => !prev)}>
              ...
            </Button>
          </SmartRow>

          <Row justify="center" style={{ height: 100, alignItems: 'center' }}>
            {showUsePick && (
              <Button
                type="primary"
                onClick={() => {
                  queryLocation('Pick', 'scanItem', setSLocation);

                  // const temp = locations.filter((i) => i.code === 'Pick');
                  // if (temp.length > 0) {
                  //   setSLocation(temp[0]);
                  //   setStep('scanItem');
                  // } else {
                  //   message.error('No matching location [Pick]');
                  // }
                }}
              >
                Use Pick
              </Button>
            )}
          </Row>

          <SmartBackButton
            onClick={() => {
              history.goBack();
            }}
          />
        </>
      )}

      {step === 'scanItem' && (
        <>
          <SmartSpin loading={fetching} />
          <SmartRow>
            <SmartFormLabel>{t('smart.movemerge.from')}</SmartFormLabel>
            <Text strong style={{ marginLeft: 4, fontSize: 18 }}>
              {sLocation?.locationCode}
            </Text>
          </SmartRow>
          <SmartSpace>
            <SmartFormLabel
              style={{ color: GreenColor, fontWeight: 600, fontSize: 18 }}
            >
              {t('smart.movemerge.scanItem')}
            </SmartFormLabel>
            <SmartScanner
              style={{ marginTop: 10, marginBottom: 8 }}
              onChangeValue={(value) => fetchProductsByLocationCode(value)}
            />
          </SmartSpace>
          <SmartBackButton
            onClick={() => {
              setStep('sourceLocation');
            }}
          />
        </>
      )}
      {step === 'targetLocation' && (
        <>
          <SmartSpin loading={fetching} />
          <SmartRow>
            <SmartFormLabel>{t('smart.movemerge.from')}</SmartFormLabel>
            <Text strong style={{ marginLeft: 4, fontSize: 18 }}>
              {sLocation?.locationCode}
            </Text>
          </SmartRow>
          <SmartRow justify="space-between">
            <Text>
              {t('common.sku')}:
              <Text strong style={{ marginLeft: 4, fontSize: 18 }}>
                {productLocations[0]?.sku}
              </Text>
            </Text>

            <Text>
              {t('common.upc')}:
              <Text strong style={{ marginLeft: 4, fontSize: 18 }}>
                {productLocations[0]?.upc}
              </Text>
            </Text>
            {isPatternCodeIncludeLotOrUom() && (
              <Space size="large" style={{ marginBottom: 8 }}>
                {lotEnable && (
                  <Typography.Text type="secondary">{`${t('common.lotNumber')}: ${
                    getMatchedPatternCode(state.matchedPatternList, PatternCodeType.LOT) || ''
                  }`}</Typography.Text>
                )}
                {uomEnable && (
                  <Typography.Text type="secondary">{`${t('common.uom')}: ${
                    getMatchedPatternCode(state.matchedPatternList, PatternCodeType.UOM) || ''
                  }`}</Typography.Text>
                )}
                {/*uomEnable && (
                  <Typography.Text type="secondary">{`${t('common.rate')}: ${
                    selectedLotUom.uomRate
                  }`}</Typography.Text>
                )*/}
                <Typography.Text type="secondary">{`Qty: ${
                  getMatchedPatternCode(state.matchedPatternList, PatternCodeType.Qty) || ''
                }`}</Typography.Text>
              </Space>
            )}
          </SmartRow>
          <SmartSpace>
            <SmartFormLabel
              style={{ color: GreenColor, fontWeight: 600, fontSize: 18 }}
            >
              {/*t('smart.movemerge.scanLocation')*/}
              Scan Target Location
            </SmartFormLabel>
            <SmartScanner
              disabled={isTargetLocationScannerDisabled()}
              onChangeValue={(value) => {
                if (value === sLocation?.locationCode) {
                  return message.error('Cannot use the same location');
                } else {
                  const temp1 = productLocations.filter(
                    (j) => j.locationCode === value
                  );
                  if (temp1.length > 0) {
                    queryLocation(value, 'scanQty', setTLocation);
                  } else {
                    Modal.confirm({
                      title: 'Are you sure to continue？',
                      icon: <ExclamationCircleOutlined />,
                      content: (
                        <Text>
                          Scanned location [<Text type="danger">{value}</Text>]
                          didn't have record of this item [
                          <Text type="danger">{productLocations[0]?.sku}</Text>]
                        </Text>
                      ),
                      okText: 'Yes',
                      onOk() {
                        queryLocation(value, 'scanQty', setTLocation);
                      },
                      onCancel() {
                        return;
                      },
                    });
                  }
                }
              }}
              style={{ marginTop: 10 }}
            />
          </SmartSpace>
          <SmartRow>
            <Text strong style={{ fontSize: 16 }}>
              {t('common.location')}:
            </Text>
          </SmartRow>
          <SmartSpace>
            {isTargetLocationScannerDisabled() && patternCodeState.message && (
              <SmartRow className="b-r-10 p-4-8 tr-bg-red-01">
                <Text style={{ fontSize: 16 }}>
                  {patternCodeState.message}
                </Text>
              </SmartRow>
            )}
            <Table
              size="small"
              rowKey={(record) =>
                `${record.locationCode}_${record.sku}_${record.lotNumber}_${record.uom}_${record.uomRate}`
              }
              bordered
              columns={getColumns()}
              dataSource={sortLocationList(productLocations)}
              onRow={onLocationTableRow}
              pagination={false}
              style={{ marginTop: 10, marginBottom: 10 }}
            />{' '}
          </SmartSpace>
          {/* <div
            style={{
              paddingLeft: 8,
              paddingRight: 8,
              marginBottom: 8,
              width: '100%',
            }}
          >
            {productLocations
              .filter((i) => i.quantity > 0)
              .map((item: any) => (
                <Text
                  key={item.locationCode}
                  style={{
                    fontSize: 16,
                    marginRight: 6,
                  }}
                >
                  <Text strong>{item.locationCode}</Text>
                  {`(${item.quantity})`}
                </Text>
              ))}
          </div> */}
          <SmartBackButton
            onClick={() => {
              setStep('scanItem');
            }}
          />
        </>
      )}
      {step === 'scanQty' && (
        <>
          <SmartSpin loading={fetching} />
          <SmartRow justify="space-between">
            <Text>
              {t('smart.movemerge.from')}:
              <Text strong style={{ marginLeft: 4, fontSize: 18 }}>
                {sLocation?.locationCode}
              </Text>
            </Text>

            <Text>
              {t('smart.movemerge.to')}:
              <Text strong style={{ marginLeft: 4, fontSize: 18 }}>
                {tLocation?.locationCode}
              </Text>
            </Text>
          </SmartRow>
          <SmartRow justify="space-between">
            <Text>
              {t('common.sku')}:
              <Text strong style={{ marginLeft: 4, fontSize: 18 }}>
                {productLocations[0]?.sku}
              </Text>
            </Text>

            <Text>
              {t('common.upc')}:
              <Text strong style={{ marginLeft: 4, fontSize: 18 }}>
                {productLocations[0]?.upc}
              </Text>
            </Text>
          </SmartRow>

          <SmartRow justify="space-between" style={{ alignItems: 'start' }}>
            {uomEnable && lotEnable && (
              <Form.Item
                label={
                  <Text
                    style={{
                      fontSize: 18,
                      color: 'rgb(86, 149, 34)',
                      fontWeight: 600,
                    }}
                  >
                    {`${t('common.lotNumber')} [${t('common.uom')}]:`}
                  </Text>
                }
              >
                <Select
                  defaultValue={getDefaultLotUom(
                    productLocations,
                    sLocation?.locationCode
                  )}
                  style={{ marginLeft: 8, width: '100%', minWidth: 200 }}
                  onChange={(value) => {
                    const temp = productLocations.filter(
                      (i) =>
                        i.locationCode === sLocation?.locationCode &&
                        value === `${i.lotNumber}_##___##_${i.uom}`
                    );
                    if (temp.length > 0) {
                      setSelectedLotUom(temp[0]);
                    } else {
                      setSelectedLotUom(undefined);
                    }
                  }}
                >
                  {productLocations
                    .filter((i) => i.locationCode === sLocation?.locationCode)
                    .map((item) => (
                      <Select.Option
                        key={`${item.lotNumber}_##___##_${item.uom}`}
                        value={`${item.lotNumber}_##___##_${item.uom}`}
                      >{`${item.lotNumber} [${item.uom}]`}</Select.Option>
                    ))}
                </Select>
              </Form.Item>
            )}

            {!uomEnable && lotEnable && (
              <Form.Item
                label={
                  <Text
                    style={{
                      fontSize: 18,
                      color: 'rgb(86, 149, 34)',
                      fontWeight: 600,
                    }}
                  >
                    {`${t('common.lotNumber')}:`}
                  </Text>
                }
              >
                <Select
                  defaultValue={getDefaultLot(
                    productLocations,
                    sLocation?.locationCode
                  )}
                  style={{ marginLeft: 8, width: '100%', minWidth: 200 }}
                  onChange={(value) => {
                    const temp = productLocations.filter(
                      (i) =>
                        i.locationCode === sLocation?.locationCode &&
                        value === i.lotNumber
                    );
                    if (temp.length > 0) {
                      setSelectedLotUom(temp[0]);
                    } else {
                      setSelectedLotUom(undefined);
                    }
                  }}
                >
                  {productLocations
                    .filter((i) => i.locationCode === sLocation?.locationCode)
                    .map((item) => (
                      <Select.Option
                        key={item.lotNumber || 'none'}
                        value={item.lotNumber}
                      >
                        {item.lotNumber}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            )}

            {uomEnable && !lotEnable && (
              <Form.Item
                label={
                  <Text
                    style={{
                      fontSize: 18,
                      color: 'rgb(86, 149, 34)',
                      fontWeight: 600,
                    }}
                  >
                    {`${t('common.uom')}:`}
                  </Text>
                }
              >
                <Select
                  defaultValue={getDefaultUom(
                    productLocations,
                    sLocation?.locationCode
                  )}
                  style={{ marginLeft: 8, width: '100%', minWidth: 200 }}
                  onChange={(value) => {
                    const temp = productLocations.filter(
                      (i) =>
                        i.locationCode === sLocation?.locationCode &&
                        value === i.uom
                    );
                    if (temp.length > 0) {
                      setSelectedLotUom(temp[0]);
                    } else {
                      setSelectedLotUom(undefined);
                    }
                  }}
                >
                  {productLocations
                    .filter((i) => i.locationCode === sLocation?.locationCode)
                    .map((item) => (
                      <Select.Option key={item.uom || 'none'} value={item.uom}>
                        {item.uom}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            )}
          </SmartRow>

          {selectedLotUom && (
            <Space size="large" style={{ marginBottom: 8 }}>
              {lotEnable && (
                <Typography.Text type="secondary">{`${t('common.lotNumber')}: ${
                  selectedLotUom.lotNumber
                }`}</Typography.Text>
              )}
              {uomEnable && (
                <Typography.Text type="secondary">{`${t('common.uom')}: ${
                  selectedLotUom.uom
                }`}</Typography.Text>
              )}
              {uomEnable && (
                <Typography.Text type="secondary">{`${t('common.rate')}: ${
                  selectedLotUom.uomRate
                }`}</Typography.Text>
              )}
            </Space>
          )}

          <SmartRow>
            <Form.Item
              label={
                <Text
                  style={{
                    fontSize: 18,
                    color: 'rgb(86, 149, 34)',
                    fontWeight: 600,
                  }}
                >
                  {t('smart.movemerge.scanItem')}:
                </Text>
              }
            >
              <Input
                autoFocus
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                style={{ marginLeft: 8 }}
                onKeyDown={handleKeyDown}
              />
            </Form.Item>
          </SmartRow>
          <SmartRow justify="space-between" style={{ alignItems: 'start' }}>
            <Form.Item
              label={
                <Text
                  style={{
                    fontSize: 18,
                    color: 'rgb(86, 149, 34)',
                    fontWeight: 600,
                  }}
                >
                  {t('common.qty')}:
                </Text>
              }
            >
              <InputNumber
                min={0}
                value={qty}
                style={{ marginLeft: 8 }}
                onChange={(value) => setQty(value)}
              />
            </Form.Item>
            <Button
              type="primary"
              disabled={!qty || qty === 0}
              onClick={() => moveProduct()}
            >
              {t('common.confirm')}
            </Button>
          </SmartRow>
          <SmartRow>
            <Text>
              {/* Last scan at: <Text>{scanTime}</Text> */}
              {t('smart.movemerge.lastScanAt', { value: scanTime })}
            </Text>
          </SmartRow>

          <SmartBackButton
            onClick={() => {
              setStep('targetLocation');
            }}
          />
        </>
      )}
      {finishDialogVisible && tLocation && sLocation && (
        <FinishDialog
          tLocation={tLocation.locationCode || ''}
          sLocation={sLocation.locationCode || ''}
          sku={productLocations[0].sku}
          upc={productLocations[0].upc}
          qty={qty}
          lotEnable={lotEnable}
          uomEnable={uomEnable}
          lotUom={selectedLotUom}
          onSubmit={(value) => {
            setFinishDialogVisible(false);
            if (value === 'home') {
              history.push('/smart');
            }
            if (value === 'sourceLocation') {
              setSLocation(undefined);
              setTLocation(undefined);
              setQty(0);
              setScanTime('');
              setStep('sourceLocation');
              setSelectedLotUom(undefined);
              isPatternCodeEnabled(state) && clearMatchedPatternList(dispatch);
            }
            if (value === 'item') {
              setTLocation(undefined);
              setQty(0);
              setScanTime('');
              setStep('scanItem');
              setSelectedLotUom(undefined);
              isPatternCodeEnabled(state) && clearMatchedPatternList(dispatch);
            }
          }}
        />
      )}
      {patternCodeSelectorVisible && (
        <PatternCodeSelector
          dispatch={dispatch}
          maskClosable={false}
          onCancel={closePatternCodeSelector}
          onClosePatternCodeSelectorWithoutSelection={onClosePatternCodeSelectorWithoutSelection}
          onSelectPatternCode={onSelectPatternCode}
          state={state}
          title="Select Pattern Code"
          visible={patternCodeSelectorVisible}
        />
      )}
      {
        <SetDefaultWarehouseDialog
          closable={dialogClosable}
          close={() => {
            setDefaultWarehouseVisible(false);
          }}
          visible={defaultWarehouseVisible}
        />
      }
    </div>
  );
}
